/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Cidr } from './Cidr';
import {
    CidrFromJSON,
    CidrFromJSONTyped,
    CidrToJSON,
} from './Cidr';

/**
 * 
 * @export
 * @interface FirewallRuleTarget
 */
export interface FirewallRuleTarget {
    /**
     * 
     * @type {Array<number>}
     * @memberof FirewallRuleTarget
     */
    ports: Array<number>;
    /**
     * 
     * @type {Cidr}
     * @memberof FirewallRuleTarget
     */
    cidr: Cidr;
}

/**
 * Check if a given object implements the FirewallRuleTarget interface.
 */
export function instanceOfFirewallRuleTarget(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "ports" in value;
    isInstance = isInstance && "cidr" in value;

    return isInstance;
}

export function FirewallRuleTargetFromJSON(json: any): FirewallRuleTarget {
    return FirewallRuleTargetFromJSONTyped(json, false);
}

export function FirewallRuleTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirewallRuleTarget {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ports': json['ports'],
        'cidr': CidrFromJSON(json['cidr']),
    };
}

export function FirewallRuleTargetToJSON(value?: FirewallRuleTarget | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ports': value.ports,
        'cidr': CidrToJSON(value.cidr),
    };
}

